<template>
    <div v-if="fileOverlayUrl" class="overlay">
        <div class="overlay-header">
            <button class="close-btn" @click="close">Luk</button>
        </div>
		<iframe :src="src" class="overlay-frame" frameborder="0" id="myiframe" style="height:100%; width:100%;"></iframe>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

export default {
    name: "FileOverlay",
    computed: {
        ...mapGetters(["fileOverlayUrl"]),
        url() {
            return encodeURIComponent(this.fileOverlayUrl)
        },
		src() {
			return `/gview?url=${this.url}&embedded=true`;
		}
    },
    methods: {
        ...mapMutations(["closeFileOverlay"]),
        close() {
            this.closeFileOverlay()
        }
    }
}
</script>

<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.7);
    display: flex;
    flex-direction: column;
    z-index: 9999;
}
.overlay-header {
    background: #222;
    color: #fff;
    padding: 10px;
    text-align: right;
}
.close-btn {
    background: #f7223f;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 16px;
    cursor: pointer;
}
.overlay-frame {
    flex: 1;
    border: none;
    background: #fff;
    width: 100%;
}
</style>
